{
	"table": {
		"titleJ": "JADRALNI LETI",
		"titleM": "MOTORNI LETI"
	},
	"modal":{
		"zapis": "Zapis urejal:",
		"namen":"Namen:",
		"naloga":"Naloga:",
		"reg":"Registracija:",
		"pilot":"Pilot:",
		"krajV":"Kraj vzleta:",
		"krajP":"Kraj pristanka:",
		"vZraku":"v zraku:",
		"vizuelno":"vizuelno:",
		"stPristankov":"Št. pristankov:",
		"opomba":"opomba:",
		"datumU":"datum urejanja:",
		"regV": "Registracija vlečnega letala: ",
		"instruktor": "Inštruktor:",
		"poletanje": "Poletanje:",
		"casO": "Čas odklopa:",
		"pristanek": "Pristanek:",
		"trajanje": "Trajanje:",
		"vleka": "Vleka:",
		"casV": "Čas vleke:"
	}
}